export default __webpack_public_path__ + "static/img3-58bd718bd72944957cfc7e0ad01602d5.webp";